/******************
 和时间相关的工具类
******************/
export default {
  // 把年,月,日拼接成字符串 占2 2019-01-01位
  formatDate: function (year, month, day) {
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + month + '-' + day
  },

  // 把年,月,日拼接成字符串, 占1位 2019-1-1
  formatDate1: function (year, month, day) {
    return year + '-' + month + '-' + day
  },

  // 格式化时间,使用方式
  // let date = new Date()
  // dateFormat("YYYY-mm-dd HH:MM", date)
  // >>> 2019-06-06 19:45
  dateFormat: function (fmt, date) {
    let ret
    let opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt)
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
    }
    return fmt
  },
  // 周期转化
  formatWeek: function (weekVal) {
    switch (weekVal) {
      case 1:
        weekVal = '星期一'
        break
      case 2:
        weekVal = '星期二'
        break
      case 3:
        weekVal = '星期三'
        break
      case 4:
        weekVal = '星期四'
        break
      case 5:
        weekVal = '星期五'
        break
      case 6:
        weekVal = '星期六'
        break
      case 0:
        weekVal = '星期日'
        break
    }
    return weekVal
  }
}



// WEBPACK FOOTER //
// ./src/common/dateUtils.js